const AppConfig = {
  api: {
    url: 'https://api.xosocny.com/'
  }
}

export default AppConfig;
